import { TOKEN_CONSTANTS } from 'constant';
import { getLocalStorage } from 'helpers/localstorage-utils';
import { useEffect } from 'react';
import { useLazyUserMeQuery } from 'service/authQuery/authQuery';

const useAuth = () => {
  const [fetchUser, { isLoading, isError }] = useLazyUserMeQuery();

  const token = getLocalStorage(TOKEN_CONSTANTS.ACCESS);
  const isAuth = Boolean(token);

  useEffect(() => {
    if (isAuth && !isLoading) {
      fetchUser('');
    }
  }, [isAuth, isLoading, fetchUser]);

  return {
    isValidAuth: isAuth,
    isLoading,
    isError
  };
};

export default useAuth;
